// use-sign-in-with-otp.ts — Auth suite, action
//
// POSTs an email magic-link request via Supabase. Surfaces Supabase's returned error
// via the standard onError handler.

'use client';

import { useMemo } from 'react';
import { supabase } from '@/lib/supabase';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export function useSignInWithOtp(): ActionResult<{ email: string }, void> {
  return useActionHook<{ email: string }, void>(
    useMemo(
      () => ({
        mutationFn: async ({ email }) => {
          const { error } = await supabase.auth.signInWithOtp({
            email: email.trim(),
            options: { emailRedirectTo: `${window.location.origin}/auth/callback` },
          });
          if (error) throw error;
        },
      }),
      [],
    ),
  );
}
